"use strict";
// noinspection TypeScriptValidateTypes
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Field = void 0;
const react_final_form_1 = require("react-final-form");
const react_1 = __importDefault(require("react"));
const identity = (value) => (value);
/* This wraps react-final-form's <Field/> component.
 * The identity function ensures form values never get set to null,
 * but rather, empty strings.
 *
 * See https://github.com/final-form/react-final-form/issues/130
 */
const Field = (props) => react_1.default.createElement(react_final_form_1.Field, Object.assign({ parse: identity, defaultValue: null }, props));
exports.Field = Field;
